<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    aria-hidden="true"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_1028"
          data-name="Rectangle 1028"
          width="48.649"
          height="46.774"
          transform="translate(0 0)"
          fill="none"
        />
      </clipPath>
    </defs>
    <g id="Icona_Negozio" transform="translate(-0.006 0)">
      <rect
        id="icon_spacer"
        width="60"
        height="60"
        transform="translate(0.006 0)"
        fill="none"
      />
      <g id="Shop" transform="translate(6.369 7)">
        <g
          id="Group_9097"
          data-name="Group 9097"
          transform="translate(-0.363 0)"
        >
          <g id="Group_9096" data-name="Group 9096" clip-path="url(#clip-path)">
            <path
              id="Path_8145"
              data-name="Path 8145"
              d="M.053,46.774,0,46.09H3.9l.044-.785c.019-.3.035-.557.035-.815q0-11.942.012-23.88a1.75,1.75,0,0,0-1.034-1.875A4.694,4.694,0,0,1,.35,14.445c-.038-1.668-.035-3.034.007-4.312A2.807,2.807,0,0,1,.71,8.925c.653-1.162,1.315-2.318,1.976-3.474C3.572,3.9,4.456,2.358,5.321.8A1.3,1.3,0,0,1,6.513,0c.038,0,.076,0,.114.005q8.889.019,17.726.019t17.7-.018C42.122,0,42.162,0,42.2,0a1.288,1.288,0,0,1,1.177.767c.869,1.572,1.747,3.107,2.626,4.643q1,1.751,1.995,3.507a2.483,2.483,0,0,1,.314,1.092c.025.924.017,1.854.008,2.783,0,.468-.008.935-.008,1.4a5.107,5.107,0,0,1-2.7,4.662,1.826,1.826,0,0,0-.848,1.255c-.037,7.5-.032,14.942-.027,22.39l0,2.739a3.814,3.814,0,0,0,.109.609l.059.224h3.741v.7Zm39.463-.767H43.87v-26.6s-.47.019-.547.019A5.355,5.355,0,0,1,38.755,16.9l-.256-.41-.253.411A5.265,5.265,0,0,1,31,18.611a5.3,5.3,0,0,1-1.7-1.692l-.249-.4-.257.393a5.41,5.41,0,0,1-4.445,2.5,5.67,5.67,0,0,1-4.535-2.474l-.261-.335-.228.358a5.261,5.261,0,0,1-4.453,2.44,5.472,5.472,0,0,1-4.5-2.5l-.259-.4L9.86,16.9A5.356,5.356,0,0,1,5.325,19.44l-.478-.013V45.972H9.3V25.563H39.516Zm-10.8,0h9.917V26.382H28.717Zm-18.641,0H27.762V38.866H10.076Zm0-8.087h17.7V26.365h-17.7ZM29.522,10.16v.3c0,.474-.012.943-.023,1.407a25.727,25.727,0,0,0,.051,3.075,4.131,4.131,0,0,0,4.106,3.674l.178,0a4.246,4.246,0,0,0,4.241-3.877c.069-.97.052-1.918.035-2.923-.008-.446-.016-.9-.016-1.354v-.3ZM20,10.465c0,.446-.008.886-.015,1.32-.016.981-.031,1.908.033,2.844a4.242,4.242,0,0,0,4.034,3.964,3.93,3.93,0,0,0,.417.021,4.076,4.076,0,0,0,3.995-3.193,42.261,42.261,0,0,0,.277-4.957v-.3H20ZM5.534,18.609A4.206,4.206,0,0,0,9.7,14.936a40.56,40.56,0,0,0,.034-4.5l-.013-.286H1.183l-.013.286A42.853,42.853,0,0,0,1.2,14.852a4.116,4.116,0,0,0,4.113,3.757l.1,0Zm37.755,0a4.2,4.2,0,0,0,4.167-3.7c.071-1.007.054-1.987.037-3.026-.008-.467-.016-.942-.016-1.428v-.3l-8.559,0v1.564c0,.316,0,.631-.006.946-.01.719-.02,1.463.04,2.2a4.279,4.279,0,0,0,4.235,3.741h0ZM10.664,10.153l-.04.66c-.018.26-.034.5-.033.746a31.416,31.416,0,0,0,.052,3.495,4.264,4.264,0,0,0,4.2,3.554h.113A4.185,4.185,0,0,0,19.1,15.092a27.467,27.467,0,0,0,.053-3.2c-.01-.476-.021-.957-.021-1.444v-.3ZM36.655,2.935C37.3,4.84,37.935,6.7,38.6,8.552a1.341,1.341,0,0,0,.989.745c1.3.026,2.554.032,3.849.032l3.884,0-1.127-1.98C45.039,5.317,43.952,3.4,42.836,1.5A1.466,1.466,0,0,0,41.78.869C40.886.845,40.015.84,39.13.84L35.944.845ZM9.612.834c-.869,0-1.719,0-2.569.025a1.475,1.475,0,0,0-1.093.525C4.85,3.242,3.809,5.077,2.718,7L1.4,9.322l3.86,0c1.276,0,2.51,0,3.743-.025a1.344,1.344,0,0,0,1.049-.622c.794-2.168,1.519-4.294,2.266-6.481L12.778.84ZM28.72,2.865c.212,1.912.416,3.75.656,5.59a1.23,1.23,0,0,0,.912.834c1.381.031,2.708.036,4.063.036l3.647,0-.72-2.1c-.66-1.937-1.288-3.777-1.941-5.61A1.227,1.227,0,0,0,34.5.876C33.46.844,32.49.839,31.5.839L28.5.843ZM17.2.836c-.943,0-1.859,0-2.775.023a1.226,1.226,0,0,0-.956.553c-.692,1.894-1.325,3.737-1.978,5.641l-.782,2.269H16.9c2.18,0,2.324-.127,2.615-2.268.179-1.325.318-2.656.459-4.021.064-.612.234-2.193.234-2.193Zm2.879,8.423H28.6L27.677.93H21.018Z"
              fill="#252525"
              stroke="#252525"
              stroke-width="0.4"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<style lang="scss" scoped></style>
